import { ListLoadingPlaceholderListItems } from 'modules/list/listPage/ListLoadingPlaceholder/ListLoadingPlaceholderListItems';
import { SearchTextbox } from '../../../../components/SearchTextbox';
import { ListFilterListSearchPortal } from '../../components/ListFilterListSearch/ListFilterListSearchPortal';
import { ListLayout } from '../../components/ListLayout';
import { ListSidebarIndicatorButton } from '../../components/ListSidebar/ListSidebarIndicatorButton';
import { ListLoadingPlaceholderBar } from './ListLoadingPlaceholderBar';
import { ListLoadingPlaceholderSidebar } from './ListLoadingPlaceholderSidebar';
import { isMobileAny } from '../../../../utils/device';

type ListLoadingSpreadsheetPlaceholderProps = {
	hasMultiselect?: boolean;
	skipNavigation?: boolean;
	title?: string;
	titleCode?: number;
	columnsCount?: number;
	rowsCount?: number;
	hasAvatar?: boolean;
	skipCollapse?: boolean;
	avatarColumnIndex?: number;
	hasColumnSwitcher?: boolean;
	skipFilters?: boolean;
	skipSearchField?: boolean;
	skipTotalItemsCount?: boolean;
};

function ListLoadingPlaceholder({
	title,
	titleCode,
	hasMultiselect,
	columnsCount = 6,
	rowsCount = 8,
	skipFilters,
	skipSearchField,
	hasAvatar,
	avatarColumnIndex = 0,
	skipCollapse,
	hasColumnSwitcher,
	skipTotalItemsCount,
	skipNavigation,
}: ListLoadingSpreadsheetPlaceholderProps) {
	return (
		<ListLayout>
			<ListLoadingPlaceholderBar
				title={title}
				titleCode={titleCode}
				skipTotalItemsCount={skipTotalItemsCount}
			/>
			<ListLoadingPlaceholderListItems
				avatarColumnIndex={avatarColumnIndex}
				columnsCount={columnsCount}
				hasAvatar={hasAvatar}
				hasMultiselect={hasMultiselect}
				skipNavigation={skipNavigation}
				rowsCount={rowsCount}
				skipCollapse={skipCollapse}
				hasColumnSwitcher={hasColumnSwitcher}
			/>
			{!skipFilters && <ListSidebarIndicatorButton disabled />}
			{!skipSearchField && (
				<ListFilterListSearchPortal searchButtonDisabled>
					<SearchTextbox
						size='small'
						className='filterListSearchTextbox'
						disabled
					/>
				</ListFilterListSearchPortal>
			)}
			{!skipFilters && !isMobileAny && <ListLoadingPlaceholderSidebar />}
		</ListLayout>
	);
}

export { ListLoadingPlaceholder };
